import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import Error from "../components/Error"
import { FetchPurchaseOrderRequest } from "../redux/constants/PurchaseOrderConstant"
import axios from "axios"
import Header from "../layout/Header"
import Sidebar from "../layout/Sidebar"
import PageTitle from "../components/PageTitle"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Autocomplete, TextField } from "@mui/material"
import { ReactComponent as Pallm } from "../assets/images/waavingpalm.svg"
import { Modal } from "react-bootstrap"
import CollapsibleTable from "../components/Step2Invoice"
import CreateInvoiceStep4 from "../components/CreateInvoiceStep4"
import InvoiceCreationStep5 from "./InvoiceCreationStep5"
import Loader from "../components/Loader"
import ErrorModal from "../components/ErrorModal"
import { getErrorMessage } from "../utils/getErrorMessage"

const CreateInvoice = () => {
  const [currentPage, setCurrentPage] = useState(1)
  const [error, setError] = useState(null)
  const [showSettingModal, setShowSettingModal] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [showError, setShowError] = useState(false)

  // New state for ErrorModal
  const [showErrorModal, setShowErrorModal] = useState(false)
  const [errorModalConfig, setErrorModalConfig] = useState({
    title: "Error",
    message: "",
    type: "error",
  })

  const dispatch = useDispatch()
  const [GRN, setGRN] = useState([])
  const [table, setTable] = useState([])
  const navigate = useNavigate()
  const [totalPages, setTotalPages] = useState(4)

  const userLogin = JSON.parse(localStorage.getItem("userInfo"))
  const token = localStorage.getItem("access")
  const vendorInformation = userLogin?.vendor_name || ""
  const [loadinng, setLoadinng] = useState(false)

  useEffect(() => {
    if (!token) {
      navigate("/sign-in")
      return
    }

    fetchData(token)

    const firstSignIn = localStorage.getItem("firstSignIn") === "true"
    if (firstSignIn) {
      setShowSettingModal(true)
    }
  }, [token, navigate])

  const fetchData = async token => {
    try {
      setLoadinng(true)
      console.log()
      dispatch({ type: FetchPurchaseOrderRequest })
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v1/vendor/purchaseorders`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )

      if (response.data.data) {
        setTable(response.data.data)
      } else {
        setErrorModalConfig({
          title: "Not Found",
          message: "No GRN created, kindly proceed to deliver orders before creating invoice",
          type: "warning",
        })
        setShowErrorModal(true)
      }
    } catch (error) {
      // Handle fetch error with ErrorModal
      setErrorModalConfig({
        title: "Error",
        message: error.response?.data?.message || "Failed to fetch purchase orders",
        type: "error",
      })
      setShowErrorModal(true)
    } finally {
      setLoadinng(false)
    }
  }

  const [grnPage, setGrnPage] = useState(0)
  const [grnRowsPerPage, setGrnRowsPerPage] = useState(5)
  const [grnCount, setGrnCount] = useState(0)

  const getGRN = async (pageArg, sizeArg) => {
    setLoadinng(true)

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v1/vendor/grns?po_id=${selectedPO.po_id}&page=${pageArg + 1}&size=${sizeArg}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )

      setGRN(response.data.data)
      setGrnCount(response.data.data.count)
      setGrnPage(pageArg)
      return true
    } catch (error) {
      console.error("Error fetching search results:", error)

      // Replace setError with ErrorModal
      setErrorModalConfig({
        title: "Failed to Load GRN",
        message: getErrorMessage(error, "Unable to fetch GRN data. Please try again."),
        type: "error",
      })
      setShowErrorModal(true)
    } finally {
      setLoadinng(false)
    }
  }

  const handleViewGrn = async () => {
    localStorage.removeItem("SelectedItems")
    localStorage.removeItem("selectedRows")
    localStorage.removeItem("selectedItemsMap")
    localStorage.removeItem("ReferenceNumber")

    const success = await getGRN(0, grnRowsPerPage)
    if (success) {
      handleNextPage()
    }
  }

  const handleGrnPageChange = newPage => {
    getGRN(newPage, grnRowsPerPage)
  }

  const handleGrnRowsPerPageChange = newSize => {
    setGrnRowsPerPage(newSize)
    getGRN(0, newSize)
  }

  const handleCloseSettingModal = () => {
    setShowSettingModal(false)
  }

  const navigateProfileSetting = () => {
    handleCloseSettingModal()
    navigate("/profile")
  }

  const [selectedPO, setselectedPO] = useState(null)

  console.log(selectedPO)

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1)
    }
  }

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1)
    }
  }

  const getPoStoreName = po => po?.Item?.[0]?.delivery_store?.store_name

  const getPoOptionLabel = po => {
    const storeName = getPoStoreName(po)
    return storeName ? `${po.po_id} — ${storeName}` : `${po.po_id}`
  }

  const filteredData = table ? table.filter(item => item.Item.length > 0) : []
  console.log(filteredData)

  useEffect(() => {
    const fetchData = async () => {
      setLoadinng(true)
      try {
        const token = localStorage.getItem("access")
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/vendor/profile`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        )

        console.log(response.data.data, "info")
        localStorage.setItem("vendorDetails", JSON.stringify(response.data.data))
      } catch (error) {
        console.error("Error:", error.message)
        localStorage.clear()
        navigate("/sign-in")
      } finally {
        setLoadinng(false)
      }
    }

    fetchData()
  }, [])

  return (
    <div>
      <Header />
      <div className="flex main-body ">
        <div className="hidden md:block">
          <Sidebar />
        </div>
        <div className="content p-3 md:w-[80%] w-full md:ml-[20%] lg:w-[86%] lg:ml-[14%]">
          <PageTitle pagetitle="Create Invoice" />

          <Modal show={showSettingModal} onHide={handleCloseSettingModal} centered>
            <Modal.Body>
              <div className="d-flex align-items-center flex-column justify-content-center">
                <Pallm />
                <div className="approval-status-message text-center">
                  <div className="text-sm">Get started!</div>
                  <div className="text-base font-bold">Welcome to VIMP</div>
                  <div className="text-sm">
                    To get started, click the button below to customize your invoice settings
                  </div>
                </div>
                <div className="flex gap-3 items-center text-sm justify-center">
                  <button
                    className="my-2 bg-white text-blue-700 border-2 border-blue-700 py-2 px-4 rounded-md hover:bg-green-700"
                    onClick={handleCloseSettingModal}
                  >
                    Skip
                  </button>
                  <button
                    className="my-2 bg-blue-600 text-white border-2 py-2 px-4 rounded-md hover:bg-blue-700"
                    onClick={navigateProfileSetting}
                  >
                    Customize Invoice Settings
                  </button>
                </div>
              </div>
            </Modal.Body>
          </Modal>

          {/* Regular Modal */}
          <Modal show={showModal} onHide={() => setShowModal(false)} centered>
            <Modal.Body>{/* Modal Content */}</Modal.Body>
          </Modal>

          {/* New ErrorModal replacing SweetAlert */}
          <ErrorModal
            show={showErrorModal}
            onHide={() => setShowErrorModal(false)}
            title={errorModalConfig.title}
            message={errorModalConfig.message}
            type={errorModalConfig.type}
          />

          {loadinng && <Loader />}

          {error && (
            <Error
              show={showError}
              message={error}
              handleShow={() => {
                setShowError(!showError)
              }}
            />
          )}

          {currentPage === 1 && (
            <div className="pb-3 bg-white  flex flex-col box-shadow my-3">
              <div className="content-container-title bg-blue-800 flex justify-between text-base items-center py-2 px-4 ">
                <span>Purchase Order</span>
                <span>
                  Step {currentPage} of {totalPages}
                </span>
              </div>
              <div className="px-4 my-4">
                <p className="text-base">Select a purchase order yet to be invoiced</p>
                <form className="flex flex-col md:flex-row justify-between mt-2 md:mt-3 gap-3 md:gap-10">
                  <div className="w-full flex flex-col md:flex-row md:items-center ">
                    <label htmlFor="vendor" className=" mr-4 text-sm mb-2 md:mb-0">
                      Vendor:
                    </label>
                    <input
                      type="text"
                      id="vendor"
                      value={vendorInformation}
                      className="mt-1 block  p-2 username-input md:w-[80%] shadow-none rounded-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 appearance-none"
                    />
                  </div>
                  <div className="w-full flex flex-col md:flex-row md:items-center">
                    <label htmlFor="poOrderID" className="text-sm w-24 md:w-36 mr-3 mb-2 md:mb-0">
                      PO Number:
                    </label>
                    <Autocomplete
                      id="combo-box-demo"
                      options={table}
                      getOptionLabel={getPoOptionLabel}
                      value={selectedPO}
                      size="small"
                      onChange={(event, newValue) => setselectedPO(newValue)}
                      className="w-full"
                      renderInput={params => (
                        <TextField
                          {...params}
                          fullWidth
                          InputProps={{
                            ...params.InputProps,
                            style: {
                              backgroundColor: "#fff",
                              height: "42px",
                              borderRadius: "0.35rem",
                            },
                          }}
                        />
                      )}
                    />
                  </div>
                </form>
              </div>
              <button
                className={`md:self-end self-center mb-3 px-4 py-2 w-[87%] md:w-36 mx-4 md:mx-0 border text-sm font-medium rounded-md transition-colors duration-300 ${
                  !selectedPO
                    ? "bg-gray-400 text-gray-800 cursor-not-allowed"
                    : "bg-blue-500 text-white hover:bg-blue-700"
                }`}
                disabled={!selectedPO}
                onClick={handleViewGrn}
              >
                View GRN
              </button>
            </div>
          )}
          {currentPage === 2 && (
            <div className="my-3">
              <CollapsibleTable
                handlePrevious={handlePrevPage}
                totalPages={totalPages}
                currentPage={currentPage}
                vendorInfo={vendorInformation}
                selectedGRN={GRN}
                selectedPO={selectedPO.po_id}
                storeName={getPoStoreName(selectedPO)}
                handleNext={handleNextPage}
                page={grnPage}
                rowsPerPage={grnRowsPerPage}
                count={grnCount}
                onPageChange={handleGrnPageChange}
                onRowsPerPageChange={handleGrnRowsPerPageChange}
              />
            </div>
          )}
          {currentPage === 3 && (
            <div className="my-3">
              <CreateInvoiceStep4
                handlePrevious={handlePrevPage}
                currentPage={currentPage}
                totalPages={totalPages}
                handleNext={handleNextPage}
                selectedPO={selectedPO.po_id}
                storeName={getPoStoreName(selectedPO)}
                vendorInfo={vendorInformation}
              />
            </div>
          )}
          {currentPage === 4 && (
            <div className="my-3">
              <InvoiceCreationStep5
                handlePrevious={handlePrevPage}
                currentPage={currentPage}
                totalPages={totalPages}
                handleNext={handleNextPage}
                selectedPO={selectedPO.po_id}
                vendorName={vendorInformation}
              />
            </div>
          )}
        </div>
      </div>
      <ToastContainer />
    </div>
  )
}

export default CreateInvoice
